<template>
  <article-layout>
   <h1>Fout</h1>
   <router-link to="/puppy">Terug</router-link>
   <h2>Er ging iets mis bij het verzenden van uw reactie</h2>
    <p>
      
    </p>
</article-layout>
</template>

<script>
import ArticleLayout from "./ArticleLayout";
export default {
  name: "MailFail",
  components: {
        ArticleLayout
    }
}
</script>

<style scoped>
    h1 {
        color: #016F70;
        font-weight: bold;
        line-height: 2;
        font-size: 3em;
        margin-top: 4vh;
        margin-bottom: 0;
    }
    h2 {
        color: #99C5C4;
        font-weight: 500;
        font-size: 1.5em;
        margin-top: 2vh;
        margin-bottom: 0.5vh;
    }
</style>